import L from "leaflet";
import "leaflet-draw";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

export function enable() {
    const editableLayers = new L.FeatureGroup();
    const markerLayers = new L.FeatureGroup();

    const department = document.getElementById("department").value;
    const status = document.getElementById("BaseDocumentViewModel_Status").value;

    //
    // If the user can add, remove, update positions, and update polygons. If this is false, then only the status can be updated.
    //
    const fullUpdate =
        status === "New" || status === "Registered" || (status === "Accepted" && department === "PortControl");

    const getLatInputField = (index) => document.getElementById(`form-latitude-input-${index}`);
    const getLngInputField = (index) => document.getElementById(`form-longitude-input-${index}`);
    let _index = 0;

    window.initMap = (index) => {
        _index = index;

        markerLayers.clearLayers();

        let latElement = getLatInputField(index);
        let lngElement = getLngInputField(index);

        if (latElement.value && lngElement.value) {
            const lat = parseFloat(latElement.value);
            const lng = parseFloat(lngElement.value);

            createMarker(lat, lng);
        }

        let polygonHiddenField = document.getElementById(
            `BaseDocumentViewModel_Positions_${_index}__PolygonJsonObject`
        );

        drawPolygonOnMap(polygonHiddenField.value, markerLayers);

        map.invalidateSize();
    };

    window.initDrawMap = (index) => {
        _index = index;

        editableLayers.clearLayers();

        let polygonHiddenField = document.getElementById(
            `BaseDocumentViewModel_Positions_${_index}__PolygonJsonObject`
        );

        drawPolygonOnMap(polygonHiddenField.value, editableLayers);

        drawMap.invalidateSize();
    };

    const map = L.map("map", { attributionControl: false }).setView([57.688111, 11.848859], 14);
    const drawMap = L.map("mapPolygon", { attributionControl: false }).setView([57.688111, 11.848859], 14);

    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
        iconRetinaUrl: markerIcon2x,
        iconUrl: markerIcon,
        shadowUrl: markerShadow
    });

    map.addLayer(markerLayers);
    drawMap.addLayer(editableLayers);

    let options = {
        position: "topright",
        draw: {
            polyline: {
                shapeOptions: {
                    color: "#f357a1",
                    weight: 3
                }
            },
            polygon: {
                shapeOptions: {
                    weight: 2,
                    color: "#bada55"
                }
            },
            circle: true,
            rectangle: {
                shapeOptions: {
                    clickable: false,
                    weight: 2
                }
            },
            marker: false,
            circlemarker: false
        },
        edit: {
            featureGroup: editableLayers,
            remove: false,
            edit: false
        }
    };

    if (fullUpdate) {
        let drawControl = new L.Control.Draw(options);
        drawMap.addControl(drawControl);
    }

    L.tileLayer
        .wms("https://opengeodata.goteborg.se/services/ortofoto/wms/v1", {
            layers: "orto_2023",
            maxNativeZoom: 19,
            maxZoom: 19,
            minZoom: 13
        })
        .addTo(map);

    L.tileLayer
        .wms("https://opengeodata.goteborg.se/services/ortofoto/wms/v1", {
            layers: "orto_2023",
            maxNativeZoom: 19,
            maxZoom: 19,
            minZoom: 13
        })
        .addTo(drawMap);

    window.updateFormWithLatLng = function (lat, lng) {
        let lngInput = document.getElementById(`form-longitude-input-${_index}`);
        let latInput = document.getElementById(`form-latitude-input-${_index}`);

        lngInput.value = lng;
        latInput.value = lat;

        lngInput.dispatchEvent(new Event("change"));
        latInput.dispatchEvent(new Event("change"));
    };

    map.on("click", (e) => {
        if (!fullUpdate) return;

        const lat = parseFloat(e.latlng.lat.toFixed(6));
        const lng = parseFloat(e.latlng.lng.toFixed(6));

        createMarker(lat, lng);
    });

    drawMap.on(L.Draw.Event.CREATED, async function (e) {
        editableLayers.clearLayers();
        let layer = e.layer;

        let geoJson = layer.toGeoJSON();

        editableLayers.addLayer(layer);

        let type = geoJson.geometry.type;
        let storedShape = {
            type: geoJson.geometry.type,
            options: layer.options
        };

        let hiddenPolygonField = document.getElementById(
            `BaseDocumentViewModel_Positions_${_index}__PolygonJsonObject`
        );

        if (type === "Polygon") {
            storedShape.latlngs = layer._latlngs[0].map((p) => [p.lat, p.lng]);
        } else if (type === "LineString") {
            storedShape.latlngs = layer._latlngs.map((p) => [p.lat, p.lng]);
        } else {
            storedShape.latlngs = [layer._latlng.lat, layer._latlng.lng];
            storedShape.radius = layer._mRadius;
        }

        hiddenPolygonField.value = JSON.stringify(storedShape);
    });

    const createMarker = (lat, lng) => {
        const latitudeString = lat.toLocaleString(undefined, {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
        });
        const longitudeString = lng.toLocaleString(undefined, {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
        });

        L.marker([lat, lng])
            .addTo(markerLayers)
            .bindPopup(
                `
                <div class="form-group">
                    <label class='form-label fw-bold' style="white-space: nowrap;">Latitud: ${latitudeString}</label> 
                    <br/> 
                    <label class='form-label fw-bold' style="white-space: nowrap;">Longitud: ${longitudeString}</label>
                    <div class='d-flex justify-content-center'>
                        <button type='button' class='btn btn-success' data-bs-dismiss="modal" onClick="updateFormWithLatLng(${lat}, ${lng})" style="white-space: nowrap;"> 
                            Spara position 
                        </button>
                    </div>
                </div>`,
                { maxWidth: "auto" }
            )
            .openPopup()
            .addEventListener("popupclose", (e) => {
                e.target.remove();
            });
    };

    function drawPolygonOnMap(polygon, layer) {
        if (polygon) {
            let parsedObj = JSON.parse(polygon);
            let type = parsedObj.type;

            let shape;
            if (type === "Polygon") {
                shape = L.polygon(parsedObj.latlngs, parsedObj.options);
            } else if (type === "LineString") {
                shape = L.polyline(parsedObj.latlngs, parsedObj.options);
            } else {
                shape = L.circle(parsedObj.latlngs, parsedObj.radius, parsedObj.options);
            }

            layer.addLayer(shape);
        }
    }
}
